import React, { useState, useEffect, useRef, useContext } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BreadcrumbMenu from './BreadcrumbMenu';
import { isLgScreen, isMdScreen, isSmScreen, isXSmScreen, isXlScreen, numericInputOnly, queryString } from '../CrackersUtil';
import { getCracker, addCrackersIntoCart } from '../AxiosAPI';
import { CrackersContext } from "../CrackersContext";
import DOMPurify from 'dompurify';

import incr from '../images/incr.png';
import decr from '../images/decr.png';
import PageLoader from './PageLoader';


function CrackersDetails() {

    const { serviceCommonData, landingPage, setLandingPage, setShowErrorToastStatus, setToastBody, userInfo, browserCart, setBrowserCart } = useContext(CrackersContext);
    const [selectedCart, setSelectedCart] = useState(null);
    const [crackersDetails, setCrackersDetails] = useState([]);
    const [crackersDetailsLoading, setCrackersDetailsLoading] = useState(true);
    const [crackersDetailsError, setCrackersDetailsError] = useState(null);
    const [windowSize, setWindowSize] = useState({width: window.innerWidth, height: window.innerHeight});
    const [prevScreenParams, setPrevScreenParams] = useState("");
    

    const location = useLocation();
    const navigate = useNavigate();

    const { crackerId } = useParams(); // Read path param

    function getCurrentPath() {
        const queryParams = queryString(new URLSearchParams(location.search));
        if (queryParams && queryParams.trim() != '') {
            return location.pathname + "?" + queryParams;
        } else {
            return location.pathname;
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        setCrackersDetailsError(true);
        const fetchCrackersDetails = async (cart) => {
            try {
                const linkToDetailView = cart ? `/crackers/${crackerId}?cart=${cart}` : `/crackers/${crackerId}`;
                console.log(userInfo);
                const data = await getCracker(userInfo, crackerId, cart, null, setShowErrorToastStatus, setToastBody, browserCart);
                if(data.status && data.status === 'failure') {
                    switch(data.message) {
                        case "unauth":
                            setLandingPage(getCurrentPath());
                            navigate(serviceCommonData["link_signin"] ? serviceCommonData["link_signin"] : '/web/signin');
                            return;
                        break;
                    }
                }
                setCrackersDetails(data);
                setCrackersDetailsLoading(false);
            } catch (error) {
                setCrackersDetailsError(error);
                setCrackersDetailsLoading(false);
            }
        };

        const params = new URLSearchParams(location.search);
        var paramStr = "";
        var passedCart = null;
        for (const [key, value] of params.entries()) {
            if(key === 'cart') {
                setSelectedCart(value);
                passedCart = value;
            } else {
                paramStr += key + "=" + value + "&";
            }
        }

        if(paramStr.trim() != '') {
            paramStr = paramStr.substring(0, paramStr.length - 1);
            setPrevScreenParams(paramStr);
        }

        fetchCrackersDetails(passedCart);

        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
          
    }, [crackerId]);

    return(
        <div>
            <Row style={{position : "sticky", top : "11%", zIndex : "1", marginBottom : "1%"}}>
                <Col xs={1}></Col>
                <Col xs={11}>
                    <BreadcrumbMenu items={[
                        { caption: "Home", link: "/web" },
                        { caption: "Crackers", link: "/web/crackers?" + prevScreenParams},
                        { caption: crackersDetails.name, activePage: true }
                    ]} />
                </Col>
            </Row>
            
            {crackersDetailsLoading ? (
                <PageLoader/>
            ) : crackersDetails && Object.keys(crackersDetails).length > 0 ?  (
                <>
                    <CrackersDetailsView
                            windowSize={windowSize}
                            data={crackersDetails}
                            selectedCart={selectedCart}/>
                </>
            ) : (
                <CrackersNotFound/>
            )}
            
        </div>
    )
}

function CrackersNotFound() {
    return(
        <>
            <div className='center_of_scrn'>
                <div>
                    <h1>Crackers not found in our service.</h1>
                    <h3>Kindly navigate back to the <a href='/web/crackers'>list view.</a></h3>
                </div>
                {/* <div>
                    <img src={agntNF}></img>
                </div> */}
            </div>
        </>
    );
}

function CrackersDetailsView({windowSize, data, selectedCart}) {
    const [loading, setLoading] = useState(false);
    const [cdMainImage, setCdMainImage] = useState('#');
    const [prevQuantity, setPrevQuantity] = useState(0);
    // const [btnCaption, setBtnCaption] = useState("Add to Cart");
    const [cartQuantity, setCartQuantity] = useState(0);
    const quantityRef = useRef(null);
    const navigate = useNavigate();
    const { serviceCommonData, landingPage, setLandingPage, setShowErrorToastStatus, setToastBody, userInfo, browserCart, setBrowserCart } = useContext(CrackersContext);
    const timeoutRef = useRef(null);

    useEffect(() => {
        setPrevQuantity(data.quantity);
        // setBtnCaption(data.quantity > 0 ? "In the cart" : "Add to Cart");
        // setCdMainImage("/client/images/4X4/1.png");
        setCdMainImage(data.images[0]);
        setCartQuantity(data.quantity);
    }, []);

    const imageContainer = {
        position: 'relative',
        width: isXSmScreen(windowSize.width) ? windowSize.width : (isSmScreen(windowSize.width) || isMdScreen(windowSize.width) || isLgScreen(windowSize.width)) ? '400px': '600px',
        // width: '400px',
        height: isXSmScreen(windowSize.width) ? windowSize.width : (isSmScreen(windowSize.width) || isMdScreen(windowSize.width) || isLgScreen(windowSize.width)) ? '400px': '600px',
        border: 'black 1px solid',
        borderRadius: '10px',
        marginBottom: (isXSmScreen(windowSize.width) || isSmScreen(windowSize.width)) ? '3%' : '0%',
    };

    const cdTextContainer = {
        marginLeft : (isXSmScreen(windowSize.width) || isSmScreen(windowSize.width)) ? '0%' : '3%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

    };

    const cdContainer = {
        marginLeft: (isXSmScreen(windowSize.width) || isSmScreen(windowSize.width) || isMdScreen(windowSize.width) || isLgScreen(windowSize.width) || isXlScreen(windowSize.width)) ? '0%' : '-10%',
        display: 'flex',
        flexDirection: (isXSmScreen(windowSize.width) || isSmScreen(windowSize.width)) ? 'column' : 'row',
        alignItems: (isXSmScreen(windowSize.width) || isSmScreen(windowSize.width)) ? 'center' : 'start',
        justifyContent: 'center',
        height: '100%',
      }

    const cdTnMouseHover = (event) => {
        const currentSrc = event.currentTarget.src;
        setCdMainImage(currentSrc);
    }

    function getStartingAge(str) {
        const regex = /age (\d+)-/;
        const match = str.match(regex);
        if (match && match[1]) {
            const age = match[1];
            return age;
        } else {
            return str;
        }
    }

    const decrQty = () => {
        let quantity = Number(quantityRef.current.value);

        if(quantity === 0) {
            return
        }

        if (quantity > 0) {
            quantity -= 1;
        }

        if(prevQuantity !== 0 && quantity === prevQuantity) {
            debounceUpdateCart(-1, 500);
        } else {
            debounceUpdateCart(quantity, 500);
        }
        setCartQuantity(quantity);
    }

    const incrQty = () => {
        let quantity = Number(quantityRef.current.value);
        quantity += 1;
        if(quantity === prevQuantity) {
            debounceUpdateCart(-1, 500);
        } else {
            debounceUpdateCart(quantity, 500);
        }
        // quantityRef.current.value = quantity;
        setCartQuantity(quantity);
    }

    const debounceUpdateCart = (qty, waitTime) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setLoading(true);
        timeoutRef.current = setTimeout(() => {
            if(qty !== -1 && qty !== prevQuantity) {
                addToCart();
            }
            setLoading(false);    
        }, waitTime);
      };

    const addToCart = async () => {
        if (selectedCart && selectedCart.trim() != '') {
            const quantity = Number(quantityRef.current.value);
            const params = {
                "cart_name": selectedCart,
                "quantity": quantity
            }
            const response = await addCrackersIntoCart(userInfo, data.id, params, setLoading, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart);
            if (response.status === 'success') {
                // if (quantity != 0) {
                //     // cartImageRef.current.src = '/client/images/f_cart.png';
                //     // setBtnCaption("In the Cart");
                // } else {
                //     // cartImageChecker(selectedCart);
                //     // setBtnCaption("Add to Cart");
                // }
                setCartQuantity(quantity);
                setPrevQuantity(quantity);
            }
        } else {
            setLandingPage("/web/crackers");
            navigate(serviceCommonData["link_signin"] ? serviceCommonData["link_signin"] : '/web/signin')
        }
    }

    return (
        <Row>
            <Col md={12} lg={8}>
                <div style={cdContainer}>
                    <div style={imageContainer}>
                        <img className='cd_mi' src={cdMainImage}></img>
                        <div className='cd_tns'>
                            {data.images.map((imgLink, index) => {
                                const leftMargin = 20 + (index * 25);
                                return (
                                    <img key={index} className='cd_tni' style={{ left: `${leftMargin}%` }} src={imgLink} alt={`Cracker image ${index + 1}`} onMouseOver={cdTnMouseHover} />
                                );
                            })}

                        </div>
                    </div>
                    <div style={cdTextContainer}>
                        <div className='cd_cnt_suitable'>
                            <h1 style={{color : "#000000"}}>{data.name}{(data.stock_status === 0) ? ("(Out of Stock)") : ("")}</h1>
                            <Row className='cd_cnt_row'>
                                <Col className='cd_cnt_lft' style={{color : "#000000"}}>Suitable for:</Col>
                                <Col className='cd_cnt_rht' style={{color : "#000000"}}>{data.filter === 'All' ? 'Adult' : 'From age ' + getStartingAge(data.filter)}</Col>
                            </Row>
                            <Row className='cd_cnt_row'>
                                <Col className='cd_cnt_lft' style={{color : "#000000"}}>Category:</Col>
                                <Col className='cd_cnt_rht' style={{color : "#000000"}}>{data.category}</Col>
                            </Row>
                            <Row className='cd_cnt_row'>
                                <Col className='cd_cnt_lft' style={{color : "#000000"}}>MRP:</Col>
                                <Col className='cd_cnt_rht' style={{color:"#000000"}}>₹ {data.mrp}</Col>
                            </Row>
                            <Row className='cd_cnt_row'>
                                <Col className='cd_cnt_lft' style={{color : "#000000"}}>Selling Price:</Col>
                                <Col className='cd_cnt_rht' style={{color:"#000000"}}>₹ {data.selling_price}</Col>
                            </Row>
                        </div>
                        <div className='cd_cnt_price'>
                            <span className='cd_cnt_price_lft' style={{color : "#4CAF50"}}><h2>Our Price: ₹ {data.offer_price}</h2></span>
                        </div>
                        {
                            (data.stock_status === 0) ? (
                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                                    <div style={{ filter: "grayscale(100%)" }}>
                                        <div className="cd_ct">
                                            <img className="cd_ct_qc" src={decr}></img>
                                            <Form.Control className="cl_cart_qnt" size="sm" type="text" ref={quantityRef} value={cartQuantity} readOnly={true} />
                                            <img className="cd_ct_qc" src={incr}></img>
                                        </div>
                                        {/* <div>
                                            <Button className="cl_ct_btn" onClick={addToCart} disabled={true}>{btnCaption}</Button>
                                        </div> */}
                                    </div>
                                </OverlayTrigger>
                                
                            ) : (
                                <div>
                                    <div className="cd_ct">
                                        <img className="cd_ct_qc" src={decr} onClick={decrQty}></img>
                                        <Form.Control className="cl_cart_qnt" size="lg" type="text" ref={quantityRef} value={cartQuantity} onChange={(e) => { setCartQuantity(e.target.value) }} onKeyDown={(e) => { numericInputOnly(e) }} onBlur={(e) => addToCart()}/>
                                        <img className="cd_ct_qc" src={incr} onClick={incrQty}></img>
                                    </div>
                                    {/* <div>
                                        <Button className="cl_ct_btn" onClick={addToCart} disabled={(prevQuantity !== 0 && prevQuantity === cartQuantity) || (cartQuantity === 0 && prevQuantity === 0)}>
                                            {!loading && btnCaption}
                                            {loading && <LoadingBorder/>}
                                        </Button>
                                    </div> */}
                                </div>
                            )
                        }
                    </div>
                </div>
            </Col>
            <Col md={12} lg={4}>
                <div>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.description) }} />
                </div>
            </Col>
        </Row>
    );
}

export default CrackersDetails;